var exports = {
  "k": "xa15a2ab7--26cfb5--container",
  "n": "xa15a2ab7--26cfb5--buttons-wrap",
};

module.exports = exports;
